<script setup>
import { useI18n } from 'vue-i18n'
import { Link } from '@inertiajs/vue3'
import { useCurrency } from '@/composables/useCurrency'
import { useInboxStore } from '@/stores/useInboxStore'
import ContactAvatar from './ContactAvatar.vue'
import PipelineStagePill from './PipelineStagePill.vue'

const props = defineProps({
  conv:     { type: Object, required: true },
  selected: { type: Boolean, default: false }
})

const { t } = useI18n()
const { formatDateTime } = useCurrency()
const store = useInboxStore()

const onClick = () => {
  if (props.conv.unread > 0) store.markOptimisticRead(props.conv.id)
}
</script>

<template>
  <Link
    :href="`/inbox/conversations/${conv.id}`"
    :only="['selected']"
    preserve-state
    preserve-scroll
    class="flex items-start gap-3 p-3 border-b border-[color:var(--line)] hover:bg-[color:var(--surfaceAlt)]"
    :class="selected ? 'bg-[color:var(--surfaceAlt)]' : ''"
    @click="onClick"
  >
    <ContactAvatar
      :avatar-url="conv.contact_avatar"
      :name="conv.customer_name || conv.supplier_name || conv.contact_name"
      :channel-type="conv.channel_type"
      :tone="conv.contact_kind === 'vehicle_source' ? 'supplier' : 'customer'"
      :size="36"
    />
    <div class="flex-1 min-w-0">
      <div class="flex items-center gap-2">
        <span class="truncate text-sm text-[color:var(--ink)]">
          {{ conv.customer_name || conv.contact_name || t('inbox.thread.unmatched') }}
        </span>
        <PipelineStagePill
          v-if="conv.pipeline_stage"
          :stage="conv.pipeline_stage"
        />
        <span
          v-if="conv.unread > 0"
          class="inline-flex items-center justify-center text-[10px] fw-value rounded-full px-1.5 py-0.5"
          :style="{ background: 'var(--accent)', color: 'var(--accentInk)' }"
        >
          {{ conv.unread }}
        </span>
      </div>
      <p class="text-xs text-[color:var(--muted)] truncate mt-0.5">
        {{ conv.preview || t('inbox.list.noMessages') }}
      </p>
    </div>
    <span class="text-[10px] text-[color:var(--muted)] fw-value whitespace-nowrap">
      {{ conv.last_message_at ? formatDateTime(conv.last_message_at) : '' }}
    </span>
  </Link>
</template>
